import { render, staticRenderFns } from "./FontSizeInput.vue?vue&type=template&id=426dfb65&scoped=true"
import script from "./FontSizeInput.vue?vue&type=script&lang=js"
export * from "./FontSizeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426dfb65",
  null
  
)

export default component.exports